import type { Compte } from './services/AccountService';

export type AccountTypeFilter = 'all' | 'compte_courant' | 'epargne' | 'credit' | 'autre';

export const ACCOUNT_TYPE_META: Record<
  Exclude<AccountTypeFilter, 'all'>,
  { label: string; shortLabel: string; badgeClass: string; chartColor: string }
> = {
  compte_courant: {
    label: 'Compte courant',
    shortLabel: 'Courant',
    badgeClass: 'bg-dark-600 text-dark-200',
    chartColor: '#60A5FA',
  },
  epargne: {
    label: "Compte d'épargne",
    shortLabel: 'Épargne',
    badgeClass: 'bg-emerald-500/20 text-emerald-400',
    chartColor: '#34D399',
  },
  credit: {
    label: 'Compte de crédit',
    shortLabel: 'Crédit',
    badgeClass: 'bg-red-500/20 text-red-400',
    chartColor: '#F87171',
  },
  autre: {
    label: 'Autre',
    shortLabel: 'Autre',
    badgeClass: 'bg-violet-500/20 text-violet-300',
    chartColor: '#A78BFA',
  },
};

export function normalizeAccountType(type?: string | null): Exclude<AccountTypeFilter, 'all'> {
  if (type === 'epargne' || type === 'credit' || type === 'autre' || type === 'compte_courant') {
    return type;
  }
  return 'compte_courant';
}

export function accountTypeLabel(type?: string | null): string {
  return ACCOUNT_TYPE_META[normalizeAccountType(type)].shortLabel;
}

export function maskIban(iban?: string | null): string {
  const clean = (iban || '').replace(/\s+/g, '');
  if (clean.length < 8) return iban || 'IBAN non renseigné';
  return `${clean.slice(0, 4)} •••• ${clean.slice(-4)}`;
}

export function sumBalances(accounts: Compte[]): number {
  return accounts.reduce((sum, a) => sum + (a.solde || 0), 0);
}
